import { Component, Inject, OnInit, signal } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProfileNewService } from 'avn/modules/features/profile-new/profile-new.service';
import { SharedCompsService } from 'avn/modules/services/shared-comps.service';
import { InputSafetyDirective } from 'avn/modules/shared/directives/input-safety.directive';

@Component({
  selector: 'app-save-list',
  templateUrl: './save-list.html',
  styleUrls: ['./save-list.scss'],
  imports: [FormsModule, ReactiveFormsModule, InputSafetyDirective]
})
export class SaveListComponent implements OnInit {
  public constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<SaveListComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly api: ProfileNewService,
    private readonly shared: SharedCompsService
  ) {}

  public saveListForm = this.fb.group({
    list_name: ['', [Validators.required]],
    description: ['']
  });

  public readonly savedList = signal<any[]>([]);

  public ngOnInit(): void {
    console.info(this.data.item_id, this.data.item_type, this.data.business_id);
    this.getLists();
  }

  public closeModal(result: any) {
    this.dialogRef.close(result);
  }

  public getLists() {
    this.api.getMyList().subscribe((response: any) => {
      console.info(response);
      this.savedList.set(response.data);
    });
  }

  public getMyListDetail(uuid: any) {
    this.api.getMyListDetail(uuid).subscribe((response) => {
      console.info('List Detail ' + JSON.stringify(response));
    });
  }

  public createList() {
    console.info(this.saveListForm);
    const params = { ...this.saveListForm.getRawValue() };
    this.api.createMyList(params).subscribe((response: any) => {
      this.addItemToList(response.data.uuid);
    });
  }

  public addItemToList(uuid: string) {
    const business_id = this.data.business_id;
    let service_id = '';
    let practitioner_id = '';
    if (this.data.item_type === 'Service') {
      service_id = this.data.item_id;
    } else if (this.data.item_type === 'Practitioner') {
      practitioner_id = this.data.item_id;
    }
    const params = {
      list_type: this.data.item_type,
      business: business_id,
      service: service_id || this.data.service_id,
      category: this.data.category,
      practitioner: practitioner_id
    };

    this.api.addToList(uuid, params).subscribe((response: any) => {
      console.info(response);
      this.shared.showSnackBar(response.message, 5);
      this.getLists();
    });
  }
}
